import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faRocket, faStar } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import DealModal from '../modules/crm/deals/AddDealModalV2';

/**
 * Demo component to test the new AddDealModalV2
 * You can use this to test the modal before integrating it into the main app
 */
const AddDealV2Demo: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="border-0 shadow-lg">
            <Card.Header className="bg-primary text-white text-center py-4">
              <FontAwesomeIcon icon={faRocket} size="2x" className="mb-3" />
              <h3 className="mb-1">New Deal Modal V2</h3>
              <p className="mb-0 opacity-75">AI-Forward Design with Complete Database Mapping</p>
            </Card.Header>
            <Card.Body className="text-center py-5">
              <FontAwesomeIcon icon={faStar} size="3x" className="text-primary mb-4" />
              <h4 className="mb-3">Ready to Test!</h4>
              <p className="text-muted mb-4">
                This new modal properly maps all database fields including the critical 
                <code className="bg-light px-2 py-1 rounded mx-1">property_address</code> 
                field for AI-powered related party discovery.
              </p>
              
              <div className="mb-4">
                <h6 className="text-success mb-2">✅ Features Included:</h6>
                <ul className="list-unstyled text-start d-inline-block">
                  <li>✅ Clean AI-forward design</li>
                  <li>✅ Complete database field mapping</li>
                  <li>✅ Property address prominently featured</li>
                  <li>✅ Real-time commission calculation</li>
                  <li>✅ Comprehensive validation</li>
                  <li>✅ Modern responsive UI</li>
                  <li>✅ Error handling and success feedback</li>
                </ul>
              </div>

              <Button 
                variant="primary" 
                size="lg"
                onClick={() => setShowModal(true)}
                className="px-5"
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Test New Deal Modal
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* The Modal */}
      <DealModal 
        show={showModal}
        onHide={() => setShowModal(false)}
        stageId={1}
        mode="create"
      />
    </Container>
  );
};

export default AddDealV2Demo;